export const MODULE_LIST = {
  medication: 'Medication',
  education: 'Education',
  gamification: 'Points & Rewards',
  measurement: 'Measurement',
  clinicalPathway: 'Clinical pathway',
  chat: 'Chat',
  appointment: 'Appointment',
  broadcast: 'Broadcasting',
  carePlan: 'Careplan',
  teleMedicine: 'TeleMedicine',
  urgentCare: 'UrgentCare',
  referral: 'Referral',
  payer: 'Payer',
  soap: 'SOAP'
}
